module.exports = {
  messages: {
    CN: {
      'articlelist.articlemanagement': '文章管理',
      'articlelist.articleList': '文章列表',
      'articlelist.articleName': '文章标题',
      'articlelist.articleNameErr': '请输入文章标题',
      'articlelist.articleLink': '文章链接',
      'articlelist.citationDistribution': '引用位置',
      'articlelist.content': '文章内容',
      'articlelist.preview': '预览',
      'articlelist.addArticle': '新增文章',
      'articlelist.editArticle': '编辑文章',
      'articlelist.descErr': '默认语言的文章内容不能为空',
      'articlelist.mobileCounter': '流量统计',
      'articlelist.noStatistical': '不统计',
      'articlelist.trackingStatistical': '追踪统计',
      'articlelist.trackingCode': '追踪码'
    },
    JP: {
      'articlelist.articlemanagement': '記事管理',
      'articlelist.articleList': '記事リスト',
      'articlelist.articleName': '記事タイトル',
      'articlelist.articleNameErr': '記事のタイトルを入力してください',
      'articlelist.articleLink': '記事リンク',
      'articlelist.citationDistribution': '引用位置',
      'articlelist.content': '記事内容',
      'articlelist.preview': 'プレビュー',
      'articlelist.addArticle': '新增文章',
      'articlelist.editArticle': '記事を編集',
      'articlelist.descErr': '既定言語の記事内容を空にすることはできません',
      'articlelist.mobileCounter': '流量统计',
      'articlelist.noStatistical': '不统计',
      'articlelist.trackingStatistical': '追踪统计',
      'articlelist.trackingCode': '追踪码'
    }
  }
};